import React from 'react';
import { Copy } from '@honda-canada/design-system-react';
import ResponseMessageTextPropTypes from './IResponseMessageText';

const ResponseMessageText = ({ messageText, copyColor }) => (
  <Copy size="small" data-testid="cy-response-box" fontFamily="bold" color={copyColor}>
    {messageText}
  </Copy>
);

ResponseMessageText.propTypes = ResponseMessageTextPropTypes;

export default ResponseMessageText;
